/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Nuestro objetivo es pasar los datos de nuestro componente `}<inlineCode parentName="p">{`<PokedexForm/>`}</inlineCode>{` hacia `}<inlineCode parentName="p">{`<Pokedex/>`}</inlineCode>{` para que ejecute la petición necesaria a la API que a su vez le devolverá datos al componente `}<inlineCode parentName="p">{`<PokedexScreen/>`}</inlineCode>{`.`}</p>
    <p>{`Aquí hay dos tipos de enfoques para lograr que esto suceda, React y Svelte pueden desencadenar eventos siempre que determinada pieza del estado cambia, en este caso el ID de nuestro Pokémon, mientras que Vue y Angular tienen que emitir funciones y valores desde el componente hijo que a su vez actualizarán todo lo necesario en el componente padre como el ID del Pokémon.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;